























































































import {FileItem, WhatsAppBulkDistrItemImpl} from "@/store/user_management/distr_moderation/types";
import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import {downloadBase64ToFile} from "@/utils/download-helper";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {InputWings} from "wings-ui-components";

@Component({components: {InputWings}})
export default class WhatsAppDistribution extends Vue {
  @Action("getBulkDistrItem") actionGetDistributionItem: any;
  @Action("actionLog") actionLog: any;

  private distribution = new WhatsAppBulkDistrItemImpl();
  private logObject: ActionLog = {};

  private editorConfig: object = {
    allowedContent: true,
    fullPage: true,
    language: this.$i18n.locale,
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Distribution",
          addititional_info: getTranslatedParams({channel: this.$route.params.channel, id: this.$route.params.id})
        }
        await this.actionGetDistributionItem(this.$route.params.id).then((data: WhatsAppBulkDistrItemImpl) => {
          this.distribution = Object.assign({}, this.distribution, data);
        });
        await this.actionLog(this.logObject);
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  isCheckToEmpty(file: FileItem): boolean{
    return file && Object.keys(file).length !== 0;
  }

  downloadFile(file: FileItem): void{
    downloadBase64ToFile(file);
  }
}
